export default {
  minFieldLength: ({ named }) => `Значение "${named('field')}" должно содержать минимум ${named('number')} символа`,
  maxFieldLength: ({ named }) => `Значение "${named('field')}" должно содержать максимум ${named('number')} символов`,
  fieldConsistLetters: ({ named }) => `Значение "${named('field')}" должно состоять из\xa0букв`,
  requiredField: ({ named }) => `Необходимо заполнить "${named('field')}"`,
  fullPhoneNumber: 'Введите полный номер телефона',
};
